import { FOCUS_RING } from "./focusRing.constants"

export const ANCHORED_CONTENT_PROPS = {
    sideOffset: 4,
    collisionPadding: 8,
} as const

export const POPOVER_TRIGGER_CLASS = `rounded-full ${FOCUS_RING} disabled:pointer-events-none disabled:text-ink-3`

export const SELECT_TRIGGER_CLASS = `flex h-[30px] min-w-8 items-center justify-center gap-1 rounded-full bg-offwhite pl-3 pr-2 text-body text-ink transition-colors hover:bg-ink/[0.07] ${FOCUS_RING} disabled:pointer-events-none disabled:text-ink-3`
